<template>
  <!-- <div
    class="displacement"
    :style="`--angle:${angle}deg;--angle2:${angle2}deg;--data:${data};--data2:${data2};--color:${color}`"
  >
    <div class="d1"></div>
    <div class="d2"></div>
    <div class="d3"></div>
    <div class="d4"></div>
    <div class="d5"></div>
    <div class="d6"></div>
    <div class="t1">
      <i class="icon el-icon-caret-bottom"></i>
      <div class="text">N</div>
    </div>
    <div class="t2">
      <i class="icon el-icon-caret-left"></i>
      <div class="text">E</div>
    </div>
    <div class="t3">
      <i class="icon el-icon-caret-top"></i>
      <div class="text">S</div>
    </div>
    <div class="t4">
      <i class="icon el-icon-caret-right"></i>
      <div class="text">W</div>
    </div>
    <div
      class="moving-point"
      :class="myStatic ? 'moving-point-animation-no' : 'moving-point-animation'"
      id="ces"
    >
      <div></div>
    </div>
  </div> -->
  <div class="displacement">
    <div class="angle">
      <div class="text">{{ this.angle }}°</div>
      <i class="icon el-icon-caret-bottom"></i>
    </div>
    <div ref="liquidEchart" class="liquidData" />
  </div>
</template>

<script>
import "echarts-liquidfill";
export default {
  props: {
    data: {
      type: Number,
      default: 40,
    },
    angle: {
      type: Number,
      default: 0,
    },
    myStatic: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        // this.data2 = oldValue;

        this.chartsLiquid = this.$echarts.init(this.$refs["liquidEchart"]);
        this.chartsLiquid.setOption({
          series: [
            {
              label: {
                normal: {
                  formatter: function (params) {
                    return newValue + "\n\n偏移量";
                  },
                },
              },
              data: [Math.abs(newValue) / 20],
            },
          ],
        });
      },
    },
    angle: {
      handler(newValue, oldValue) {
        this.angle2 = oldValue;
      },
    },
  },
  data() {
    return {
      // angle2: 0,
      // data2: 0,
      // color: "#000",
      chartsLiquid: null,
    };
  },
  mounted() {
    this.initLiquidEchart();
  },
  methods: {
    initLiquidEchart() {
      setTimeout(() => {
        this.chartsLiquid = this.$echarts.init(this.$refs["liquidEchart"]);
        // 把配置和数据放这里
        let that = this;
        this.chartsLiquid.setOption({
          series: [
            {
              type: "liquidFill",
              radius: "90%",
              data: [Math.abs(this.data) / 20],
              color: ["rgba(72,150,218,1)"],
              label: {
                normal: {
                  color: "#fff",
                  insideColor: "transparent",
                  formatter: function (params) {
                    return that.data + "\n\n偏移量";
                  },
                  textStyle: {
                    fontSize: 14,
                    fontFamily: "Franklin Gothic Medium",
                  },
                },
              },
              outline: {
                show: true,
                borderDistance: 5,
                itemStyle: {
                  borderColor: "rgba(72,150,218,1)",
                  borderWidth: 2,
                },
              },
              backgroundStyle: {
                color: "rgba(72,150,218,0.6)",
              },
            },
          ],
        });
      }, 50);
    },
  },
};
</script>

<style lang="scss" scoped>
// .displacement {
//   //   background-color: #aaa;
//   position: relative;
//   .d1,
//   .d2,
//   .d3,
//   .d4,
//   .d5,
//   .d6 {
//     position: absolute;
//     border-radius: 50%;
//     width: calc(var(--px) * 2);
//     height: calc(var(--px) * 2);
//     top: calc(50% - var(--px));
//     left: calc(50% - var(--px));
//   }
//   .d1 {
//     --px: 10%;
//     border: 1px dashed red;
//   }
//   .d2 {
//     --px: 15%;
//     border: 1px dashed yellow;
//   }
//   .d3 {
//     --px: 20%;
//     border: 2px solid green;
//   }
//   .d4 {
//     --px: 25%;
//     border: 1px dashed yellow;
//   }
//   .d5 {
//     --px: 30%;
//     border: 1px dashed red;
//   }
//   .d6 {
//     --px: 35%;
//     border: 1px solid dimgray;
//   }
//   .t1,
//   .t2,
//   .t3,
//   .t4 {
//     --px: 70px;
//     position: absolute;
//     color: blue;
//     .icon {
//       position: absolute;
//       height: 20px;
//       width: 20px;
//       text-align: center;
//       font-size: 14px;
//       line-height: 20px;
//     }
//   }
//   .t1 {
//     width: 20px;
//     top: calc(50% - 35% - 20px);
//     left: calc(50% - 10px);
//     font-size: 16px;
//     .icon {
//       top: 14px;
//     }
//     .text {
//       height: 20px;
//       width: 100%;
//       text-align: center;
//     }
//   }
//   .t2 {
//     width: 20px;
//     height: 20px;
//     top: calc(50% - 10px);
//     left: calc(50% + 35% + 0px);
//     font-size: 16px;

//     .icon {
//       left: -14px;
//     }
//     .text {
//       line-height: 20px;
//       height: 20px;
//       width: 100%;
//       text-align: center;
//     }
//   }
//   .t3 {
//     width: 20px;
//     height: 20px;
//     top: calc(50% + 35% + 0px);
//     left: calc(50% - 10px);
//     font-size: 16px;
//     .icon {
//       top: -14px;
//     }
//     .text {
//       line-height: 20px;
//       height: 20px;
//       width: 100%;
//       text-align: center;
//     }
//   }
//   .t4 {
//     width: 20px;
//     height: 20px;
//     top: calc(50% - 10px);
//     left: calc(50% - 35% - 20px);
//     font-size: 16px;
//     .icon {
//       left: 14px;
//     }
//     .text {
//       line-height: 20px;
//       height: 20px;
//       width: 100%;
//       text-align: center;
//     }
//   }
//   .moving-point-animation {
//     animation: movingP 0.5s infinite;
//     > div {
//       animation: movingD 0.5s infinite;
//     }
//   }
//   .moving-point-animation-no {
//     transform: rotate(var(--angle));
//     > div {
//       top: calc(50% - (var(--data) * 0.092592) + 0.277778vh);
//     }
//   }
//   .moving-point {
//     height: 100%;
//     width: 100%;
//     position: absolute;
//     > div {
//       position: absolute;
//       height: 6px;
//       width: 6px;
//       border-radius: 50%;
//       left: calc(50% - 3px);
//       top: calc(50% - 3px);
//       background-color: white;
//     }
//   }
//   @keyframes movingP {
//     0% {
//       transform: rotate(var(--angle2));
//     }
//     100% {
//       transform: rotate(var(--angle));
//     }
//   }
//   @keyframes movingD {
//     0% {
//       top: calc(50% - ((var(--data2) * 0.5%) + 20%) - 3px);
//       // top: calc(50% - 20%)
//     }
//     100% {
//       top: calc(50% - ((var(--data) * 0.5%) + 20%) - 3px);
//     }
//   }
// }

.displacement {
  height: 100%;
  width: 100%;
  .angle {
    text-align: center;
      color: white;
    .text {
      font-size: 16px;
      margin-left: 10px;
    }
    .icon{
      font-size: 16px;
      margin-top: -5px;
      // height: 30px;
      // width: 30px;
    }
  }
  .liquidData {
      margin-top: -5px;
    // width: 140px;
    // height: 140px;
    height: calc(100% - 30px);
    width: 100%;
  }
}
</style>